import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import PageHead from "@/components/feature/PageHead";

const COMPANY_NAME = "NetBasis International";

const title = "Technischer Support";
const heroImage = "https://net-basis.net/Bilder/technical-support-dach-customer-service.webp";
const heroAlt = "Hand mit Schraubendreher bedient digitale Oberfläche für technischen Support im DACH-Markt.";
const heroClaimLine1 = "Kundenservice";
const heroClaimLine2 = "mit Beratung vor Ort!";
const benefitsTitle = "Wie Sie von unserer Expertise im Bereich __Technischer Support__ profitieren:";
const h2Intro = "NetBasis International bietet auf Wunsch umfangreichen lokalen technischen Support, was für unsere Herstellerpartner bedeutet, eine hohe Verfügbarkeit an technischem Kundendienst vor Ort gewährleisten zu können. Dadurch profitieren Kunden unverzüglich und umfassend von Wert und Nutzen der von uns vertretenen Produkte und Lösungen.";
const p1Text = "Unser hochspezialisierter Service hilft Kunden und Partnern, Produkte und Lösungen schnell und einfach einzusetzen sowie eventuelle Probleme zu beheben. Dabei sichert die direkte Verbindung von NetBasis International zu unseren Herstellerpartnern die konstant hohe Supportqualität im gesamten DACH-Raum.";
const bottomClaim = "NetBasis International - drive to excellence with excellent drivers !";

const benefits = [
  "Beantwortung von generellen Fragen zur Anwendung und Verwendung von Produkten und Lösungen",
  "Kompetente Unterstützung mit und bei speziellen Betriebsinformationen",
  "Zuverlässige Bereitstellung von Installations- und Konfigurationsanleitungen",
  "Professionelle Vor-Ort-Installations- und Einrichtungshilfe",
  "Schneller lokaler Support per Telefon, E-Mail und Internet",
  "Präzise Fehleranalyse und Fehlerbehebung mittels moderner Fernwartung",
  "Identifizierung und Überprüfung etwaiger Fehler und deren zugrundeliegenden Ursachen",
  "Erarbeitung konkreter Behebungsvorschläge für identifizierte Fehler und Fehlfunktionen",
  "Fachgerechte Wartung gemäß entsprechender Absprachen und Service Level Agreements",
  "Strukturierter Multi-Tier- und Multi-Level-Support für komplexe ITK-Systeme",
];

export default function TechnischerSupportDePage() {
  return (
    <div className="min-h-screen flex flex-col">
      <PageHead
        title="Technischer Support | NetBasis International"
        description="Zuverlässiger lokaler First- und Second-Level-Support zur Sicherung einer hohen Kundenzufriedenheit in der DACH-Region."
        ogUrl="https://net-basis.net/de/services/business-development/technischer-support"
      />
      <Header />

      <main className="flex-1 pt-20 md:pt-24">
        {/* Hero image */}
        <section className="w-full bg-white py-4 md:py-6 lg:py-8">
          <div className="w-full max-w-[1100px] mx-auto">
            <div className="relative w-full h-[320px] md:h-[420px] lg:h-[500px] overflow-hidden">
              <img loading="lazy"
                src={heroImage}
                alt={heroAlt}
                title={title}
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>

              <div className="absolute inset-0 z-20 flex items-start justify-center pt-[10%] md:pt-[8%] lg:pt-[10%] pointer-events-none">
                <p
                  className="text-3xl md:text-4xl lg:text-5xl font-normal text-white drop-shadow-[0_1px_4px_rgba(0,0,0,0.6)] text-center leading-[1.15] md:leading-[1.5] animate-[technischerSupportTextSlide_12s_ease-in-out_infinite]"
                  style={{ fontFamily: '"Open Sans", sans-serif' }}
                >
                  <span className="block md:inline">{heroClaimLine1}</span>{" "}
                  <span className="block md:inline">{heroClaimLine2}</span>
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Content */}
        <section className="py-6 md:py-8 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto">
            <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-5 md:mb-7">
              {title}
            </h2>

            <h1 className="font-semibold text-foreground-950 leading-relaxed text-sm md:text-base mb-4">
              {h2Intro}
            </h1>

            <div className="space-y-4 text-foreground-950 leading-relaxed text-sm md:text-base">
              <p>{p1Text}</p>
            </div>

            {/* Benefits heading with italic word */}
            <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mt-8 md:mt-10 mb-5 md:mb-7">
              {benefitsTitle.split("__").map((part, i) =>
                i % 2 === 1 ? <em key={i}>{part}</em> : part
              )}
            </h2>

            {/* Benefits with checkmarks */}
            <div className="space-y-1.5 md:space-y-2 text-foreground-950 leading-relaxed text-sm md:text-base">
              {benefits.map((benefit, idx) => (
                <div key={idx} className="flex items-start gap-2 md:gap-3">
                  <div className="w-5 h-5 flex-shrink-0 flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-primary-600 text-base md:text-lg"></i>
                  </div>
                  <p>{benefit}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Bottom claim */}
        <section className="py-6 md:py-10 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto text-center">
            <p className="font-heading text-lg md:text-xl font-bold text-primary-600">
              {bottomClaim}
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}